export function getImages(text: string): string {
    let images = "";
    if (text?.includes("https")) {
        images = `<img src="${text}" aria-hidden="true"/>`;
    }
    return images;
}
